var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pos-documents',{attrs:{"configurl":_vm.updateSale}})
}
var staticRenderFns = []

export { render, staticRenderFns }